var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"backbutton"},[_c('SprButton',{staticClass:"back",attrs:{"size":4,"title":_vm.$t('customerForm.previousButton'),"preicon":"chevron-left","click-event":"back"},on:{"back":_vm.onBackClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }